import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

export default ({ groupId }) => {
  const source = useAsObservableSource({ groupId });
  const presenter = useLocalStore(() => ({
    get group() {
      return Entities.GroupsStore.getGroupById(source.groupId);
    },
  }));

  return presenter;
};
